import { Component, Input } from '@angular/core';
import { DataTablesService } from '../../../../../core';
import { isPeriodicidadeAnual, isPeriodicidadePeriodo, isPeriodicidadeSemestral, isPeriodicidadeTrimestral } from '../../../../../shared';
import { crossSellObrigatorio } from '../../../../common/cross-sell';
import { TipoClassificacao } from '../../adapters';

/** Propriedades do component */
interface Props {
    possuiAnos: boolean;
    isShowTrimestral: boolean;
    isShowSemestral: boolean;
    isShowAnual: boolean;
}

@Component({
    selector: 'sgt-produtividade-classificacoes-kpi-table',
    templateUrl: './produtividade-classificacoes-kpi-table.component.html',
    styleUrls: ['./produtividade-classificacoes-kpi-table.component.less']
})
export class ProdutividadeClassificacoesKPITableComponent {
    /** Propriedades do component */
    props: Props;
    /** Tipo de classificação */
    @Input() tipoClassificacao: TipoClassificacao;
    /** Periodicidade de exibição */
    @Input() periodicidade: number

    /** Indicador de Cross Sell Obrigatório */
    readonly CROSS_SELL_OBRIGATORIO = crossSellObrigatorio;

    // Datatable
    isCreatingDataTable: boolean
    @Input() idDataTable = 'produtividadeClassificacaoKPITable';
    private dataTable: any;

    constructor(private dataTablesService: DataTablesService) { }

    /** Seta as propriedades do component */
    private setProps(periodicidade: number) {
        this.props = {
            possuiAnos: this.tipoClassificacao?.anos && this.tipoClassificacao.anos.length > 0,
            isShowTrimestral: false,
            isShowSemestral: false,
            isShowAnual: false
        };

        // Trimestral
        if (isPeriodicidadeTrimestral(periodicidade)) {
            this.props.isShowTrimestral = true;
        }

        // Semestral
        if (isPeriodicidadeSemestral(periodicidade)) {
            this.props.isShowTrimestral = true;
            this.props.isShowSemestral = true;
        }

        // Anual
        if (isPeriodicidadeAnual(periodicidade)) {
            this.props.isShowTrimestral = true;
            this.props.isShowSemestral = true;
            this.props.isShowAnual = true;
        }

        // Período
        if (isPeriodicidadePeriodo(periodicidade)) {
            this.props.isShowTrimestral = true;
            this.props.isShowSemestral = true;
            this.props.isShowAnual = true;
        }
    }

    /** Cria a dataTable */
    private createTable(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs: [
                    {orderable: true, targets: 0}
                ],
                order: [[0, 'asc']],
                searching: false,
                info: false,
                paging: false,
                processing: true,
            }).then(dataTable => {
                this.dataTable = dataTable;
                resolve();
            })
            .catch(() => {});
        });
    }

    show() {
        this.setProps(this.periodicidade);

        if (this.dataTable) {
            this.dataTablesService.destroyTable(this.dataTable);
            this.dataTable = null;
        }

        this.createTable();
    }

    ngOnDestroy(): void {
        this.dataTablesService.destroyTable(this.dataTable);
    }
}
